import { SelectContentProps } from 'components/ui/Forms';
import { DriverDocType } from 'interfaces/driver-doc-types';
import { apiHub } from 'services';

export const useHubDriverDocTypes = () => {
  const fetchDocTypes = async () => {
    const { data } = await apiHub.get<DriverDocType[]>(`/driver-doc-type`);

    const comboOptions: SelectContentProps[] = data.map((docType: any) => ({
      name: docType.name,
      value: docType.id,
    }));

    return { comboOptions, data };
  };

  return { fetchDocTypes };
};
